import draggable from './module/draggable'
import clipboard from './module/clipboard'
import has from './module/has-permission'

const directives = {
  draggable,
  has,
  clipboard
}

export default directives
